"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateRelative = exports.formatDateDistance = exports.formatDate = void 0;

var _dateFns = require("date-fns");

var _nb = _interopRequireDefault(require("date-fns/locale/nb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var parse = function parse(date) {
  if (typeof date === "string") {
    return (0, _dateFns.parseISO)(date);
  }

  return date;
};

var formatDate = function formatDate(date) {
  var frmat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dd MMMM yyyy";
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _nb["default"];
  return (0, _dateFns.format)(parse(date), frmat, {
    locale: locale
  });
};

exports.formatDate = formatDate;

var formatDateDistance = function formatDateDistance(frm) {
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _nb["default"];
  var opts = arguments.length > 3 ? arguments[3] : undefined;
  return (0, _dateFns.formatDistance)(parse(frm), parse(to), _objectSpread({
    locale: locale
  }, opts));
};

exports.formatDateDistance = formatDateDistance;

var formatDateRelative = function formatDateRelative(frm, to) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _nb["default"];
  var opts = arguments.length > 3 ? arguments[3] : undefined;
  return (0, _dateFns.formatRelative)(parse(frm), parse(to), _objectSpread({
    locale: locale
  }, opts));
};

exports.formatDateRelative = formatDateRelative;